export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1024
}

export const EMITTER_PROPS = {
  cart: {
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    change: 'cart.change',
    render: 'cart.render'
  },
  product: {
    updateVariantOption: 'product.update_variant_option',
    updateVariant: 'product.update_variant',
    openModalGallery: 'product.open_modal_gallery',
    addToCart: 'product.add_to_cart',
    quickAdd: 'product.quick_add'
  },
  notice: {
    global: 'notice.global'
  },
  collection: {
    filter: 'collection.filter'
  }
}

export const RECENTLY_CONFIG = {
  cookieName: `${Shopify.shop}_recently_viewed`, // Please change prefix every new project 'gamma_' to project name
  cookieSkusName: `${Shopify.shop}_recently_viewed_skus`, // Please change prefix every new project 'gamma_' to project name
  expireTime: 60 * 60 * 24 * 7, // set cookie expire time to 7 days
  maxLimit: 10
}
